const SORT_DESCENDING = 'D';
export default SORT_DESCENDING;